document.addEventListener('rebuy:smartcart.ready', function () {
    // var reviewElement = document.createElement("div");
    // reviewElement.className = "rebuy-review"
    // var footerTextElement = document.createElement("div");
    // footerTextElement.className = "rebuy-cart-footer-policy"

    // var reviews = [
    //     { title: "", text: "I love using them in my classroom!", author: "Eugenia S." },
    //     { title: "", text: "Great pens! Fun for everyone.", author: "Romi." },
    //     { title: "", text: "Love the markers for doodling Highly recommend!!", author: "Beverly L." },
    //     { title: "", text: "Just as I remember. Absolutely love writing with them", author: "Stacy J." },
    //     { title: "", text: "I bought these for my granddaughter and she absolutely LOVES them!", author: "Beverly L." }
    // ];

    // function randomIntFromInterval(max, min) {
    //     return Math.floor(Math.random() * (max - min) + min)
    // }

    // setInterval(() => {
    //     const result = randomIntFromInterval(reviews.length, 0)
    //     document.querySelector(".rebuy-review-text").innerHTML = `
    //         <h4>${reviews[result].title}</h4>
    //         <p>${reviews[result].text}</p>
    //         <small>${reviews[result].author}</small>
    //     `
    // }, 3000)

    // reviewElement.innerHTML = `
    //     <div class="rebuy-review-content">
    //         <div class="review-image">
    //             <img src="https://cdn.shopify.com/s/files/1/0287/8020/0014/files/trust-badge-2023_600x_1.png?v=1675801033" />
    //         </div>
    //         <div class="rebuy-review-content-text">
    //             <img src="https://cdn.shopify.com/s/files/1/0287/8020/0014/files/Frame_180.png?v=1675801049" />
    //             <div class="rebuy-review-text">
    //                 <h4>${reviews[0].title}</h4>
    //                 <p>${reviews[0].text}</p>
    //                 <small>${reviews[0].author}</small>
    //             </div>
    //         </div>
    //     </div>
    // `;

    // const parentNode = document.querySelector(".rebuy-cart__flyout-recommendations")

    var footerTextElement = document.createElement("div");
    footerTextElement.className = "rebuy-cart-footer-policy"
    footerTextElement.innerHTML = "90 days no-questions-asked return policy";
    document.querySelector(".rebuy-cart__flyout").appendChild(footerTextElement);

    // document.querySelector(".rebuy-cart__flyout-recommendations").appendChild(reviewElement)
    // document.querySelector(".rebuy-cart__flyout").appendChild(footerTextElement)
    // document.querySelector(".rebuy-button span b").innerHTML = `Secure Checkout <i class="rebuy-button-icon prefix fas fa-lock"></i>`
}); 